import { render, staticRenderFns } from "./ChatBoxNote.vue?vue&type=template&id=8999e95a&scoped=true&"
import script from "./ChatBoxNote.vue?vue&type=script&lang=js&"
export * from "./ChatBoxNote.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxNote.vue?vue&type=style&index=0&id=8999e95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8999e95a",
  null
  
)

export default component.exports